module.exports = __webpack_public_path__ + "media/images/flags/sn-472a4da317e89b214a377458c869604e.svg";